var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('settings-payment-checkout'),_c('v-divider',{staticClass:"basic500 my-5"}),_c('settings-recurring-plan'),_c('v-divider',{staticClass:"basic500 my-5"}),_c('settings-fees-tips')],1)}
var staticRenderFns = []

export { render, staticRenderFns }